import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  LONG_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";

export const getVehicleVariantExists = (
  variantCode: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicle-variant-exists", variantCode],
    queryFn: (): Promise<boolean> => {
      return fetchWithAuth<boolean>("getVehicleVariantExists", variantCode);
    },
    enabled: isQueryEnabled(options),
    staleTime: LONG_STALE_TIME,
  });
};
